import Carousel from "~/components/carousel"
import { VideoCard } from "~/components/cards"
import dayjs from "dayjs"
import type { EmblaOptionsType } from "embla-carousel-react"
import { cn } from "~/utils/shadecn"
import { useMemo } from "react"

const options: EmblaOptionsType = {
  loop: false,
  duration: 20,
  slidesToScroll: 1,
  inViewThreshold: 0.5,
  breakpoints: {
    "(min-width: 640px)": {
      slidesToScroll: 3,
    },
    "(min-width: 1024px)": {
      slidesToScroll: 4,
    },
  },
}

export const VideoGrid = ({
  loggedIn,
  isAgeVerified,
  isPaymentVerified,
  videos,
  source,
  sourceID,
  rentedAt,
  videoClassNames,
}: {
  loggedIn: boolean
  isAgeVerified?: boolean
  isPaymentVerified?: boolean
  videos: any[]
  source?: string
  sourceID?: number
  rentedAt?: any[]
  videoClassNames?: string
}) => {
  return (
    <div className="flex gap-2 w-full justify-center flex-wrap">
      {videos?.map((video: any, index: number) => (
        <VideoCard
          key={index}
          loggedIn={loggedIn}
          isAgeVerified={isAgeVerified}
          isPaymentVerified={isPaymentVerified ?? false}
          video={video}
          source={source}
          sourceID={sourceID}
          rentedAt={rentedAt && rentedAt[index]}
          className={cn(
            "flex-none w-80 md:w-auto md:h-48 md:hover:scale-[1.15] md:hover:z-20 transition delay-200 duration-300",
            videoClassNames
          )}
        />
      ))}
    </div>
  )
}

export const VideoCarousel = ({ loggedIn, isAgeVerified, isPaymentVerified, videos, className, source, sourceID }: any) => {
  const sortedVideos = useMemo(() => {
    return videos?.sort((a: any, b: any) => dayjs(b.PublishedAt!).unix() - dayjs(a.PublishedAt!).unix())
  }, [videos])
  return (
    <Carousel options={options} className={className}>
      {sortedVideos?.map((video: any, index: number) => (
        <VideoCard
          loggedIn={loggedIn}
          isAgeVerified={isAgeVerified}
          isPaymentVerified={isPaymentVerified ?? false}
          video={video}
          key={index}
          source={source}
          sourceID={sourceID}
          className="md:hover:scale-[1.15] md:hover:z-20 transition delay-200 duration-300 flex-[0_0_100%] sm:flex-[0_0_33.3%] lg:flex-[0_0_25%]"
        />
      ))}
    </Carousel>
  )
}
